import { Autocomplete, AutocompleteProps } from '@conexasaude/conexa-hero'
import { ReactElement } from 'react'
import {
  Controller,
  Control,
  Path,
  ControllerRenderProps,
  ControllerFieldState,
  UseFormStateReturn,
} from 'react-hook-form'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AutocompleteControlType<T> = AutocompleteProps<any> & {
  name: Path<T>
  control?: Control<T>
}

export function AutocompleteControl<T>({
  name,
  control,
  onChange: onInputChange,
  ...rest
}: AutocompleteControlType<T>): ReactElement {
  const getCustomValue = value => {
    return value || null
  }

  function handleControllerRenderInput({
    field,
  }: {
    field: ControllerRenderProps<T, Path<T>>
    fieldState: ControllerFieldState
    formState: UseFormStateReturn<T>
  }) {
    return (
      <Autocomplete
        onChange={(event, item, ...props) => {
          field.onChange(item)
          if (onInputChange) {
            onInputChange(event, item, ...props)
          }
        }}
        onBlur={field.onBlur}
        value={getCustomValue(field.value)}
        ref={field.ref}
        {...rest}
      />
    )
  }

  return (
    <Controller
      name={name}
      control={control}
      render={handleControllerRenderInput}
    />
  )
}

export default AutocompleteControl
